import { createTypes } from 'reduxsauce';

export default createTypes(
  `
    SLA_CONFIG_GET_REQUEST
    SLA_CONFIG_GET_REQUEST_SUCCESS
    SLA_CONFIG_GET_REQUEST_ERROR

    SLA_CONFIG_UPDATE_REQUEST
    SLA_CONFIG_UPDATE_REQUEST_SUCCESS
    SLA_CONFIG_UPDATE_REQUEST_ERROR

    SLA_CONFIG_UPDATE_AGENT_CAPC_REQUEST
    SLA_CONFIG_UPDATE_AGENT_CAPC_REQUEST_SUCCESS
    SLA_CONFIG_UPDATE_AGENT_CAPC_REQUEST_ERROR


    CLEAR_STORE
  `,
  {
    prefix: '',
  }
);
